import React from 'react';

const Dashboard = () => {
  const containerStyle = {
    padding: '1.5rem',
    backgroundColor: '#f9fafb',
    minHeight: '100vh'
  };

  const titleStyle = {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#111827',
    marginBottom: '0.5rem'
  };

  const subtitleStyle = {
    fontSize: '0.875rem',
    color: '#6b7280',
    marginBottom: '2rem'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '1.5rem',
    marginBottom: '2rem'
  };

  const cardStyle = {
    backgroundColor: 'white',
    padding: '1.5rem',
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb'
  };

  const statCardStyle = {
    ...cardStyle,
    display: 'flex',
    alignItems: 'center'
  };

  const iconStyle = {
    width: '3rem',
    height: '3rem',
    borderRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '1rem'
  };

  const quickActionGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1rem'
  };

  const quickActionStyle = {
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '0.5rem',
    padding: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    textAlign: 'center'
  };

  const quickActionIconStyle = {
    width: '2rem',
    height: '2rem',
    borderRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 0.5rem'
  };

  const activityItemStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 0',
    borderBottom: '1px solid #f1f5f9'
  };

  const activityDotStyle = {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    marginRight: '0.75rem'
  };

  return (
    <div style={containerStyle}>
      {/* Page Title */}
      <div>
        <h1 style={titleStyle}>Dashboard</h1>
        <p style={subtitleStyle}>ISP Radius Admin Paneli</p>
      </div>

      {/* Stats Grid */}
      <div style={gridStyle}>
        {/* Total Users */}
        <div style={statCardStyle}>
          <div style={{ ...iconStyle, backgroundColor: '#dbeafe' }}>
            <svg style={{ width: '1.5rem', height: '1.5rem', color: '#2563eb' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
          </div>
          <div>
            <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#6b7280', margin: 0 }}>
              Toplam Kullanıcı
            </p>
            <p style={{ fontSize: '1.5rem', fontWeight: '600', color: '#111827', margin: 0 }}>
              1,234
            </p>
          </div>
        </div>

        {/* Active Subscribers */}
        <div style={statCardStyle}>
          <div style={{ ...iconStyle, backgroundColor: '#dcfce7' }}>
            <svg style={{ width: '1.5rem', height: '1.5rem', color: '#16a34a' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#6b7280', margin: 0 }}>
              Aktif Abone
            </p>
            <p style={{ fontSize: '1.5rem', fontWeight: '600', color: '#111827', margin: 0 }}>
              987
            </p>
          </div>
        </div>

        {/* Monthly Revenue */}
        <div style={statCardStyle}>
          <div style={{ ...iconStyle, backgroundColor: '#fef3c7' }}>
            <svg style={{ width: '1.5rem', height: '1.5rem', color: '#d97706' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
            </svg>
          </div>
          <div>
            <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#6b7280', margin: 0 }}>
              Aylık Gelir
            </p>
            <p style={{ fontSize: '1.5rem', fontWeight: '600', color: '#111827', margin: 0 }}>
              ₺45,678
            </p>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div style={cardStyle}>
        <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '1rem', margin: 0 }}>
          Hızlı İşlemler
        </h2>
        <div style={quickActionGridStyle}>
          <button style={{ ...quickActionStyle, backgroundColor: '#eff6ff', borderColor: '#bfdbfe' }}>
            <div style={{ ...quickActionIconStyle, backgroundColor: '#3b82f6' }}>
              <svg style={{ width: '1rem', height: '1rem', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </div>
            <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1e40af', margin: 0 }}>Kullanıcı Ekle</p>
          </button>

          <button style={{ ...quickActionStyle, backgroundColor: '#f0fdf4', borderColor: '#bbf7d0' }}>
            <div style={{ ...quickActionIconStyle, backgroundColor: '#22c55e' }}>
              <svg style={{ width: '1rem', height: '1rem', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#166534', margin: 0 }}>Paket Yönetimi</p>
          </button>

          <button style={{ ...quickActionStyle, backgroundColor: '#faf5ff', borderColor: '#e9d5ff' }}>
            <div style={{ ...quickActionIconStyle, backgroundColor: '#a855f7' }}>
              <svg style={{ width: '1rem', height: '1rem', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#7c3aed', margin: 0 }}>Blog Yönetimi</p>
          </button>

          <button style={{ ...quickActionStyle, backgroundColor: '#fff7ed', borderColor: '#fed7aa' }}>
            <div style={{ ...quickActionIconStyle, backgroundColor: '#f97316' }}>
              <svg style={{ width: '1rem', height: '1rem', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#c2410c', margin: 0 }}>Raporlar</p>
          </button>
        </div>
      </div>

      {/* Recent Activities */}
      <div style={cardStyle}>
        <h2 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '1rem', margin: 0 }}>
          Son Aktiviteler
        </h2>
        <div>
          <div style={activityItemStyle}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ ...activityDotStyle, backgroundColor: '#22c55e' }}></div>
              <div>
                <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#111827', margin: 0 }}>
                  Yeni kullanıcı kaydı
                </p>
                <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>
                  john@example.com
                </p>
              </div>
            </div>
            <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>2 saat önce</span>
          </div>
          
          <div style={activityItemStyle}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ ...activityDotStyle, backgroundColor: '#3b82f6' }}></div>
              <div>
                <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#111827', margin: 0 }}>
                  Paket güncellemesi
                </p>
                <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>
                  Premium paket
                </p>
              </div>
            </div>
            <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>4 saat önce</span>
          </div>
          
          <div style={activityItemStyle}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ ...activityDotStyle, backgroundColor: '#f59e0b' }}></div>
              <div>
                <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#111827', margin: 0 }}>
                  Ödeme alındı
                </p>
                <p style={{ fontSize: '0.75rem', color: '#6b7280', margin: 0 }}>
                  ₺150.00
                </p>
              </div>
            </div>
            <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>6 saat önce</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;